// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2iUXk","label":"LabeledBox_label__Pq_NT"};